<p>user-detail works!</p>
